export enum AskErrorKind {
  Generic = 0,
  InsufficientCredit = 1,
  AnalystDisabled = 2,
  RateLimited = 3,
  ValidationFailed = 4,
  ServerFailure = 5,
  ConnectionLost = 6,
}

export interface AskErrorView {
  icon: string;
  title: string;
  message: string;
  canRetry: boolean;
}

export const ASK_ERROR_VIEWS: Record<AskErrorKind, AskErrorView> = {
  [AskErrorKind.Generic]: {
    icon: 'error_outline',
    title: 'Something went wrong',
    message: "We couldn't get an answer. Check your connection and try again.",
    canRetry: true,
  },
  [AskErrorKind.InsufficientCredit]: {
    icon: 'toll',
    title: 'Out of AI credits',
    message: 'Your organization is out of AI credits. Contact your administrator to add more.',
    canRetry: false,
  },
  [AskErrorKind.AnalystDisabled]: {
    icon: 'block',
    title: 'AI analyst not available',
    message: "The AI analyst isn't enabled for your organization. Contact your administrator to turn it on.",
    canRetry: false,
  },
  [AskErrorKind.RateLimited]: {
    icon: 'hourglass_empty',
    title: 'Slow down a little',
    message: "You've reached the request limit for the AI analyst. Please wait a moment and try again.",
    canRetry: false,
  },
  [AskErrorKind.ValidationFailed]: {
    icon: 'error_outline',
    title: "That question can't be sent",
    message: 'Your question is too long. Please shorten it and try again.',
    canRetry: false,
  },
  [AskErrorKind.ServerFailure]: {
    icon: 'error_outline',
    title: 'Something went wrong',
    message: 'The analyst failed to complete your request. Retrying may help.',
    canRetry: true,
  },
  [AskErrorKind.ConnectionLost]: {
    icon: 'wifi_off',
    title: 'Connection lost',
    message: 'We lost the connection to the server. If the analyst was still working, it may finish on its own. Reload the page to check before asking again.',
    canRetry: false,
  },
};
